import { render } from "./NewsItem.vue?vue&type=template&id=1e998877"
import script from "./NewsItem.vue?vue&type=script&lang=js"
export * from "./NewsItem.vue?vue&type=script&lang=js"

import "./NewsItem.vue?vue&type=style&index=0&id=1e998877&lang=css"
script.render = render

export default script